export enum ITipoProcesso {
    FILTRO = 1,
    REPROCESSO = 2,
    CONTAGEM = 3
}